/** Schedules a callback on the next animation frame (browser only). */
const scheduleGuideTourAnimationFrame = (
  callback: FrameRequestCallback
): void => {
  window.requestAnimationFrame(callback)
}

/** Runs `callback` after two animation frames (layout settle). */
export const runAfterGuideTourLayoutFrames = (callback: () => void): void => {
  if (typeof window === 'undefined') {
    return
  }

  scheduleGuideTourAnimationFrame(() => {
    scheduleGuideTourAnimationFrame(callback)
  })
}

/** Resolves a promise after the standard post-scroll reveal delay. */
export const resolveAfterGuideTourPostScrollReveal = (
  resolve: () => void,
  delayMs: number
): void => {
  window.setTimeout(() => resolve(), delayMs)
}
